import { useActions } from "../../../../../hooks/useActions";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import { CustomCheckbox } from "../../../../../share/Input/Input";
import { useTranslation } from "react-i18next";
import { CheckboxList } from "../../../../../share/filters";
import { FilterIdsEnum } from "../../../../../store/reducers/_maps/main/mapFilters/types";
import FilterButtonWithModal from "../../../../../share/filters/FilterButtonWithModal";
import { entityTypeFilterTranslationMap } from "../../../../../constants/filterTranslationMapping";
import useSearchParams from "../../../../../hooks/useSearchParams";
import { AvailableCC } from "../../../../../constants/constants";

const EntityTypeFilter = () => {
  const filterId: FilterIdsEnum = "usaidEntityType";
  const { entity_type_array } = useTypedSelector(
    (state) => state.usaidMapFilters
  );
  const { entity_type } = useTypedSelector(
    (state) => state.mapUSAIDInfo.params
  );
  const {
    toggleUSAIDEntityTypeFilter,
    USAIDEntityTypeFilterClean,
    applyFilter,
  } = useActions();

  const handleChange = (value: string) => {
    toggleUSAIDEntityTypeFilter(value);
  };

  const handleClean = () => {
    USAIDEntityTypeFilterClean();
  };

  const handleClick = () => {
    applyFilter();
  };

  const { t: tType } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.usaid.typeFilter",
  });

  const { t: tOption } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.usaid.typeFilter.values",
  });

  const typeFilterText = tType("title");
  const pinText = entity_type_array.length > 0 && entity_type_array.length;

  const isUaRegion =
    useSearchParams().getSearchParams().region === AvailableCC.ua;

  return (
    <FilterButtonWithModal
      title={typeFilterText}
      pinText={pinText}
      filterId={filterId}
      onClear={handleClean}
      left={-204}
    >
      <CheckboxList>
        {entity_type?.length &&
          entity_type.sort().map((value: string) => (
            <CustomCheckbox
              value={value}
              key={value}
              checked={entity_type_array.includes(value)}
              onChange={() => handleChange(value)}
              onClick={() => handleClick()}
            >
              {isUaRegion
                ? tOption(entityTypeFilterTranslationMap[value])
                : value}
            </CustomCheckbox>
          ))}
      </CheckboxList>
    </FilterButtonWithModal>
  );
};

export default EntityTypeFilter;
